export default {
    ordersLayout: {
        back: "Kembali",
        emptyOrders: "Anda belum memiliki pesanan.",
        loading: "Memuat",
        storeLabel: "Toko",
        totalLabel: "Total",
        storeAddressPending: "Alamat akan segera tersedia",
        productNameFallback: "Produk",
        ecListTitle: "Pesanan Anda",
        ecStatusInStore: "Status: pembelian di toko",
        ecOrderNumber: "Nomor pesanan: {{order_number}}",
        ecDateStore: "{{date}} · {{store_name}}",
        ecCountTotalOne: "{{count}} barang: total {{amount}}",
        ecCountTotalOther: "{{count}} barang: total {{amount}}",
        ecViewOrder: "Lihat pesanan >",
        ecViewOrderA11y: "Lihat pesanan {{order_number}}",
        ecBackToOrders: "Kembali ke pesanan Anda",
        ecInStoreDate: "Pembelian di toko – {{date}}",
        ecProductsOne: "Produk",
        ecProductsOther: "Produk",
        ecSku: "Ref. {{sku}}",
        ecQty: "Jumlah: {{qty}}",
        ecWarrantyExpired: "Garansi berakhir",
        ecWarrantyActive: "Dalam garansi",
        ecSubtotalOne: "Subtotal – {{count}} barang",
        ecSubtotalOther: "Subtotal – {{count}} barang",
    }
}



// WEBPACK FOOTER //
// ./src/locales/id/index.js